// @ts-ignore

/*******************************************************
 * Copyright (C) 2010-Present Avant Assessment
 * All Rights Reserved
 *******************************************************/

import React, {useState} from "react"
import Button from "react-bootstrap/Button"
import ApiService from "../../services/ApiService"
import {
    Box,
    Checkbox,
    Grid, MuiThemeProvider,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core"
import Table from "@material-ui/core/Table"
import {SUFResult} from "../../services/ApiService"
import {theme} from "../../styles/MuiThemes"
import {loadingSpinnerStore} from "../../app/common/loaders/LoadingSpinnerStore"

const VERSION = "2.0.0"

//  state interface that we use to store the state of the component
interface CodeGen {
    selectedProduct: string,
    selectedFile: File | null,
    success: boolean,
    error: string,
    state:string,
    sufresult: SUFResult[],
}


function CodeGen() {

    //  just gets the date, instead of date + time
    function date(date:string): string{
        return date.split(",")[0]
    }


    //  set initial state
    const [state, setState] = useState<CodeGen>({
        selectedProduct: "",
        selectedFile: null,
        success: true,
        error: "",
        state: "starting",
        sufresult: []
    })

    //  helper print f'n
    // function printState(){
    //     for(let i = 0; i < state.sufresult.length; i++){
    //         console.log(
    //             i +
    //             " Product: " + state.sufresult[i].product,
    //             " success: " + state.sufresult[i].success as string,
    //             " error: " + state.sufresult[i].error)
    //     }
    // }


    //  makes headers for 2 times we have to display a table
    function TableHeader(displayProducts: boolean){

        //  displayProducts will be false in the case where we use this element for the student table
        let headCells


        if(!displayProducts) {
            //  display individual rows for each product/student combo (3rd/4th page)
            headCells = [
                {id: 'product', disablePadding: true, label: 'Product'},
                {id: 'state', disablePadding: true, label: 'State'},
                {id: 'organization', disablePadding: true, label: 'Organization'},
                {id: 'sub-organization', disablePadding: true, label: 'Sub-Organization'},
                {id: 'location', disablePadding: true, label: 'Testing Group'},
                {id: 'language', disablePadding: true, label: 'Language'},
                {id: 'open-test-window', disablePadding: true, label: 'Open Test Window'},
                {id: 'close-test-window', disablePadding: true, label: 'Close Test Window'},
                {id: 'student-username', disablePadding: true, label: 'Student Code'},
                {id: 'teacher-username', disablePadding: true, label: 'Teacher Code'}
            ]

        }
        //  display products (2nd page)
        else{
            headCells = [
                {id: 'product', disablePadding: true, label: 'Product'},
                {id: 'state', disablePadding: true, label: 'State'},
                {id: 'organization', disablePadding: true, label: 'Organization'},
                {id: 'refNum', disablePadding: true, label: 'Reference Number'},
                {id: 'error', disablePadding: true, label: 'Error'}
            ]
        }

        //  return selected header row to be used in the table
        return (
            <TableHead>
                <TableRow>
                    <TableCell>
                    </TableCell>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={'left'}
                        >{headCell.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )


    }


    //  creates csv and downloads it onto the users computer
    function downloadCSV(){
        console.log("downloadCSV ", state.sufresult)


        const xlsxHeaders: string =
            "State, " +
            "Organization, " +
            "Sub-Organization, " +
            ", " +
            "Testing Group, " +
            "Language, " +
            "Open Date, " +
            "Close Date, " +
            "Test Code, " +
            "Password, " +
            "User Type" +
            "\n"


        //  sets an individual line to display errors correctly in the csv
        // function checkError(product: SUFResult){
        //     product.sufrows.forEach((row) => {
        //         if(row.error != null){
        //             row.openDate = ""
        //             row.closeDate = ""
        //             //  avoiding !!
        //             if(row.student)
        //                 row.student.username = row.error
        //             else
        //                 row.student = {username: row.error, pw: ""}
        //
        //             if(row.teacher)
        //                 row.teacher.username = ""
        //             else
        //                 row.teacher = {username: "", pw: ""}
        //         }
        //     })
        // }



        let validProducts: string[] = []

        //  filter so only valid products are displayed in the csv
        state.sufresult.forEach((product) => {
            //  set errors to specific rows in products
            // checkError(product)
            if (product.product != null) {
                validProducts.push(product.product)
            }
        })

        const csv: string[] = []

        for(let i = 0; i < state.sufresult.length; i++){

            //  only add to csv if there were no errors at the scope of SUFRow
            if( validProducts.find(function(product) { return state.sufresult[i].product == product }) != undefined) {

                if (validProducts.length != 1) {
                    csv.push("(" + (i + 1) + "/" + validProducts.length + "), Product: " + state.sufresult[i].product + "\n")
                } else {
                    csv.push("Product: " + state.sufresult[i].product + "\n")
                }

                csv.push(xlsxHeaders)

                // TODO: The below should be wrapped in a custom data type so we can keep consistant

                state.sufresult[i].sufrows.forEach((row) => {
                    if(row.teacher && row.student && row.openDate && row.closeDate) {
                        if(row.error == null) {
                            csv.push(state.sufresult[i].state + ","+state.sufresult[i].org+","+row.locationName+","+","+row.groupName+","+row.language+","+date(formatDate(row.openDate))+","+date(formatDate(row.closeDate))+","+row.student.username+","+row.student.pw+","+"Test Takers"+"\n")
                            csv.push(","+","+","+","+","+","+","+","+row.teacher.username+","+row.teacher.pw+","+"Proctor/Results Login"+"\n")
                        }
                        //  prints error if it exists for this row
                        else{
                            csv.push(state.sufresult[i].state+","+state.sufresult[i].org+","+row.locationName+","+","+row.groupName+","+row.language+","+","+","+row.error+","+","+","+"\n")
                            csv.push(","+","+","+","+","+","+","+","+","+","+"\n")
                        }



                    }
                })
                csv.push("\n")
            }
        }

        const blob = new Blob(csv, {type: "text/csv;charset=utf8;"})
        const element = document.createElement("a")
        document.body.appendChild(element)
        element.setAttribute("href", window.URL.createObjectURL(blob))

        //  if 3 of products > 1 name file Codes.csv else name file <product name>.csv
        if(state.sufresult.length != 1) {
            element.setAttribute("download", "Codes.csv")
        }
        else{
            element.setAttribute("download", state.sufresult[0].product + ".csv")
        }

        element.style.display = ""
        element.click()
        document.body.removeChild(element)

    }


    function UploadButton(){

        if(state.selectedFile) {
            //console.log(state.selectedFile.name)
        }

        if(state.selectedFile && !state.selectedFile.name.includes(".xls")){
            setState({...state, state: "starting", error: "incorrect file type"})
            alert("Incorrect file type. Please try again")
            return
        }


        //  if file has been selected, send to backend and wait for response to display parsed sheet
        if(state.selectedFile){
            loadingSpinnerStore.hideLoadingSpinner = false
            ApiService.uploadAndValidateSUF(state.selectedFile).then(
                (res: SUFResult[] ) => {
                    setState({...state, state: "uploaded", sufresult: res})
                    loadingSpinnerStore.hideLoadingSpinner = true
                },
                (error:any) => {
                    setState({...state, state: "ERROR", error: error.message})
                    alert("Please select a file to submit")
                })
        }
    }


    //  this function takes in an array  of strings (product names) and returns the corresponding list of SUFResult
    function filterProducts(selectedProducts: string[]){

        const products: Array<SUFResult> = []
        let inError: Array<SUFResult> = []

        //  filter sufResult by
        for(const i of selectedProducts){
            for(const j of state.sufresult){
                //  if product is selected and there is no error in that tab
                if(i === j.product && j.success){
                    //  add product to return array
                    products.push(j)
                }
                //  if product is in error and selected, add to array to send error to user
                if(i === j.product && !j.success){
                    inError.push(j)
                }
            }
        }

        //  if the user selected products that have errors, alert them
        if(inError.length != 0){
            return []
        }

        //  if user selected products without errors, return products
        return products

    }

    function formatDate(date: string){
        let myDate = new Date(parseInt(date))
        return myDate.toLocaleString()
    }


    function submitCodes() {

        let selectedSUFs: SUFResult[] = []



        //  if product is selected, add it to the array to return to the backend
        state.sufresult.forEach((product) => {
            if (selectedProducts.find(function (selProduct) {
                return selProduct == product.product
            }) != undefined ){
                selectedSUFs.push(product)
            }
        })

        if(selectedSUFs.length == 0){
            alert("Please select at least one product without errors")
            return
        }

        //  this is needed in order to reset state->sufresult after the codes are submitted
        // setState({...state, ...{SUFResult: []}})

        loadingSpinnerStore.hideLoadingSpinner = false
        ApiService.submitSUF(selectedSUFs).then(r => {
            setState({...state, state: "dlcsv", sufresult: r})
            loadingSpinnerStore.hideLoadingSpinner = true
        })
    }

    var selectedProducts: string[] = []

    function StudentTable(){

        const toggleProductCheckbox = (product: string) => {
            let newSelected = selectedProducts

            //  if product isnt selected, add to array
            if(selectedProducts.indexOf(product) === -1){
                selectedProducts.push(product)
            }
            //  else remove from array
            else{
                selectedProducts = newSelected.filter(p => p !== product)
            }
        }

        if(state.sufresult.length == 1){
            selectedProducts.push(state.sufresult[0].product)
        }


        let header = TableHeader(false)
        return(
            <div>
                {state.sufresult.map((tab, index) => (
                    <Box>
                        <h1>
                            {state.sufresult.length > 1 && state.state !== "dlcsv" && (
                                <Checkbox onChange={() => toggleProductCheckbox(tab.product)} color="primary"/>
                            )}
                            {tab.product}
                        </h1>
                        <TableContainer>
                            <Table>
                                {header}
                                <TableBody>
                                    {tab.sufrows && (
                                        tab.sufrows.map((row) => (
                                            <>
                                                {row.success != "false" && row.student && row.teacher && row.openDate != undefined && row.closeDate != undefined && (
                                                    <>
                                                        <TableRow
                                                            hover

                                                            selected={false}
                                                        >
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" > {tab.product} </TableCell>
                                                            <TableCell component="th" scope="row" > {tab.state} </TableCell>
                                                            <TableCell component="th" scope="row" > {tab.org} </TableCell>
                                                            <TableCell component="th" scope="row" > {row.locationName} </TableCell>
                                                            <TableCell component="th" scope="row" > {row.groupName} </TableCell>
                                                            <TableCell component="th" scope="row" > {row.language} </TableCell>
                                                            <TableCell component="th" scope="row" > {date(formatDate(row.openDate!!))} </TableCell>
                                                            <TableCell component="th" scope="row" > {date(formatDate(row.closeDate!!))} </TableCell>
                                                            <TableCell component="th" scope="row" > {row.student.username} </TableCell>
                                                            <TableCell component="th" scope="row" > {row.teacher.username} </TableCell>
                                                        </TableRow>
                                                    </>

                                                )}
                                                {row.success == "false" && (
                                                    <>
                                                        <TableRow
                                                            hover
                                                            selected={false}
                                                        >
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" >Error: </TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" style={{color: "red"}}>{row.error}</TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                            <TableCell component="th" scope="row" ></TableCell>
                                                        </TableRow>
                                                    </>

                                                )}
                                            </>

                                        ))
                                    )}


                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                ))}

            </div>


        )

    }


    //  makes call to backend to insert selected products
    function createCodesButton(selectedProducts: string[]){

        //  check to see if products have been selected
        if(selectedProducts.length == 0){
            alert("Please select a product.")
            return
        }

        let products = filterProducts(selectedProducts)

        //  check to see if products have been selected that don't have errors
        if(products.length == 0){
            alert("Please make sure that you have not selected a product with errors.")
            return
        }

        //  if products have been selected, send to backend to get preview data
        loadingSpinnerStore.hideLoadingSpinner = false
        ApiService.checkSUF(products).then(
            (r => {
                setState({...state, state: "submitted", sufresult: r})
                loadingSpinnerStore.hideLoadingSpinner = true
            })
        )

    }

    //  displays previews of products in SUF with errors if there are any
    function ProductTable(){

        var [selectedProducts, setProducts] = useState<string[]>([])

        //  function to keep track of selected product to return to backend
        const toggleProduct = (product:string) => {

            let newSelected = selectedProducts

            if(selectedProducts.indexOf(product) === -1){
                setProducts([...selectedProducts, product])
            }
            //  check if product is already selected
            else {
                //  if product is not in selected, add it
                setProducts(newSelected.filter(p => p !== product))
            }
        }


        let header = TableHeader(true)

        //  display product name and lines corresponding with that sheet
        return(
            <>
                <MuiThemeProvider theme={theme}>
                    <Grid item xs={8}>
                        <TableContainer>
                            <Table>
                                {header}
                                <TableBody>
                                    {
                                        state.sufresult.map((row, index) => (
                                            //  todo: check if SUFResult should be null or [] to start
                                            //     useeffect hook to change things on loading
                                            //      make state vars for things like loading bars
                                            <TableRow
                                                key={index}
                                                hover
                                                selected={false}
                                            >
                                                {row.success == "false" && (
                                                    <>
                                                        <TableCell component="th" scope="row"> </TableCell>
                                                        {row.tabNum == 7 && (
                                                            //  special case for hebrew bc there is no differentiation in product name
                                                            <TableCell component="th" scope="row"> 4s - Hebrew </TableCell>
                                                        )}
                                                        {row.tabNum != 7 && (
                                                            <TableCell component="th" scope="row" > {row.product} </TableCell>
                                                        )}
                                                        <TableCell align="left">{row.state}</TableCell>
                                                        <TableCell align="left">{row.org}</TableCell>
                                                        <TableCell align="left">{row.refNum}</TableCell>
                                                        <TableCell align="left">{row.error}</TableCell>
                                                    </>
                                                )}
                                                {row.success == "true" && (
                                                    <>
                                                        <Checkbox onChange={() => toggleProduct(row.product)} color="primary"/>
                                                        <TableCell component="th" scope="row"> {row.product}</TableCell>
                                                        <TableCell align="left">{row.state}</TableCell>
                                                        <TableCell align="left">{row.org}</TableCell>
                                                        <TableCell align="left">{row.refNum}</TableCell>
                                                        <TableCell align="left">None</TableCell>
                                                    </>
                                                )}

                                            </TableRow>
                                        ))}


                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Button onClick={() => createCodesButton(selectedProducts)}>Create Codes</Button>
                    </Grid>
                </MuiThemeProvider>
            </>
        )
    }


    function onFileChange(e:any){
        const newState = state
        newState.selectedFile = e.target.files[0]
        setState(newState)
    }

    //  reset to initial state if they press the cancel button
    function cancelSession(){
        setState({...state,
            selectedProduct: "",
            selectedFile: null,
            success: true,
            error: "",
            state: "starting",
            sufresult: []
        })
    }


    return (


        <>
            <Grid container spacing = {3}>
                <Grid item xs={12}>
                    <h1>CodeGen {VERSION}</h1>

                    {state.state == "starting" && (
                        <h2>Upload Your SUF</h2>
                    )}

                    {state.state == "uploaded" && (
                        <h2>Select Products</h2>
                    )}

                    {state.state == "submitted" && (
                        <h2>Preview Codes</h2>
                    )}
                    {state.state == "dlcsv" && (
                        <h2>Download Codes</h2>
                    )}

                </Grid>

                {state.state === "starting" && (
                    <Grid item xs={12} container spacing={0}>

                        {state.state === "starting" && (
                            <input type="file" name="file" onChange={onFileChange}/>)}

                        {state.state === "starting" && (
                            <Button onClick={UploadButton}>
                                Upload File
                            </Button>
                        )}

                    </Grid>
                )}


                <Grid item xs={12} spacing={10} justify={"center"}>

                    {state.state === "uploaded" && (
                        <ProductTable/>
                    )}

                    {(state.state === "submitted" || state.state === "dlcsv") && state.sufresult != undefined && (
                        <StudentTable/>
                    )}

                    {state.state === "submitted" && (
                        <Button size="lg" onClick={submitCodes}>
                            Submit
                        </Button>
                    )}

                    {state.state === "dlcsv" && (
                        <Button onClick={downloadCSV}>
                            Download Codes
                        </Button>
                    )}

                    {state.state !=  "starting" && state.state !=  "dlcsv" && (
                        <Button size="lg" onClick={cancelSession}>
                            Cancel
                        </Button>
                    )}

                    {state.state ===  "dlcsv" && (
                        <Button onClick={cancelSession}>
                            Upload Another SUF
                        </Button>
                    )}


                </Grid>
            </Grid>


        </>

    )


}


export default CodeGen;